import { defineComponent, reactive } from "vue";
import { Log } from "~/extensions/utils";
import TopLinkCard from "../top/components/TopLinkCard.vue";
import TopInformationList from "./components/TopInformationList.vue";
import TopMenuCard from "../top/components/TopMenuCard.vue";
import { auth } from "~/core/Auth";
import { UserKb } from "~/extensions/utils/DefineTypes";
const log = Log.create("Top");
export default defineComponent({
    name: "TopPage",
    components: { TopLinkCard, TopMenuCard, TopInformationList },
    setup() {
        let isMt = auth.user?.userKbn === UserKb.Mt;
        const html = reactive({
            value: ""
        });
        return {
            html,
            isMt
        };
    }
});
